// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"organism2-m__wrapper__iLVlx"};